module.exports = __webpack_public_path__ + "static/media/speedup_opt2.9f725821.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Screens/Home/speedup_opt2.gif
// module id = 404
// module chunks = 0